import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = ({ handleToggle }) => {
  const [notifOpen, setNotifOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);

  const notifRef = useRef(null);
  const userRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) setNotifOpen(false);
      if (userRef.current && !userRef.current.contains(e.target)) setUserOpen(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <header>
      <div className="topbar d-flex align-items-center">
        <nav className="navbar navbar-expand gap-3">

          <div className="mobile-toggle-menu" onClick={handleToggle}>
            <i className="bx bx-menu"></i>
          </div>

          <h2>Dashboard</h2>

          <div className="top-menu ms-auto">
            <ul className="navbar-nav align-items-center gap-1">
              <li className="nav-item dropdown dropdown-large" ref={notifRef}>
                <div
                  className="nav-link position-relative"
                  style={{ cursor: "pointer" }}
                  onClick={() => setNotifOpen(!notifOpen)}
                >
                  <span className="alert-count">8</span>
                  <i className="bx bx-bell"></i>
                </div>

                {notifOpen && (
                  <div className="dropdown-menu dropdown-menu-end show" style={{ width: "350px" }}>
                    <div className="msg-header px-3 py-2 d-flex justify-content-between">
                      <p className="msg-header-title mb-0">Notifications</p>
                      <p className="msg-header-badge mb-0">8 New</p>
                    </div>
                    <div className="header-notifications-list">
                      <Link className="dropdown-item" href="javascript:;">
                        <div className="d-flex align-items-center">
                          <div className="user-online">
                            <img src="images/avatars/avatar-1.png" className="msg-avatar" alt="user avatar" />
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="msg-name">Daisy Anderson<span className="msg-time float-end">5 sec
                              ago</span></h6>
                            <p className="msg-info">The standard chunk of lorem</p>
                          </div>
                        </div>
                      </Link>
                      <Link className="dropdown-item" href="javascript:;">
                        <div className="d-flex align-items-center">
                          <div className="notify bg-light-danger text-danger">dc
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="msg-name">New Orders <span className="msg-time float-end">2
                              min
                              ago</span></h6>
                            <p className="msg-info">You have recived new orders</p>
                          </div>
                        </div>
                      </Link>
                      <Link className="dropdown-item" href="javascript:;">
                        <div className="d-flex align-items-center">
                          <div className="user-online">
                            <img src="images/avatars/avatar-2.png" className="msg-avatar" alt="user avatar" />
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="msg-name">Althea Cabardo <span className="msg-time float-end">14
                              sec ago</span></h6>
                            <p className="msg-info">Many desktop publishing packages</p>
                          </div>
                        </div>
                      </Link>
                      <Link className="dropdown-item" href="javascript:;">
                        <div className="d-flex align-items-center">
                          <div className="notify bg-light-success text-success">
                            <img src="images/app/outlook.png" width={25} alt="user avatar" />
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="msg-name">Account Created<span className="msg-time float-end">28 min
                              ago</span></h6>
                            <p className="msg-info">Successfully created new email</p>
                          </div>
                        </div>
                      </Link>
                      <Link className="dropdown-item" href="javascript:;">
                        <div className="d-flex align-items-center">
                          <div className="notify bg-light-info text-info">Ss
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="msg-name">New Product Approved <span className="msg-time float-end">2 hrs ago</span></h6>
                            <p className="msg-info">Your new product has approved</p>
                          </div>
                        </div>
                      </Link>
                      <Link className="dropdown-item" href="javascript:;">
                        <div className="d-flex align-items-center">
                          <div className="user-online">
                            <img src="images/avatars/avatar-4.png" className="msg-avatar" alt="user avatar" />
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="msg-name">Katherine Pechon <span className="msg-time float-end">15
                              min ago</span></h6>
                            <p className="msg-info">Making this the first true generator</p>
                          </div>
                        </div>
                      </Link>
                      <Link className="dropdown-item" href="javascript:;">
                        <div className="d-flex align-items-center">
                          <div className="notify bg-light-success text-success"><i className="bx bx-check-square" />
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="msg-name">Your item is shipped <span className="msg-time float-end">5 hrs
                              ago</span></h6>
                            <p className="msg-info">Successfully shipped your item</p>
                          </div>
                        </div>
                      </Link>
                      <Link className="dropdown-item" href="javascript:;">
                        <div className="d-flex align-items-center">
                          <div className="notify bg-light-primary">
                            <img src="images/app/github.png" width={25} alt="user avatar" />
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="msg-name">New 24 authors<span className="msg-time float-end">1 day
                              ago</span></h6>
                            <p className="msg-info">24 new authors joined last week</p>
                          </div>
                        </div>
                      </Link>
                      <Link className="dropdown-item" href="javascript:;">
                        <div className="d-flex align-items-center">
                          <div className="user-online">
                            <img src="images/avatars/avatar-8.png" className="msg-avatar" alt="user avatar" />
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="msg-name">Peter Costanzo <span className="msg-time float-end">6 hrs
                              ago</span></h6>
                            <p className="msg-info">It was popularised in the 1960s</p>
                          </div>
                        </div>
                      </Link>
                    </div>

                  </div>
                )}
              </li>
            </ul>
          </div>

          {/* User Profile */}
          <div className="user-box dropdown px-3" ref={userRef}>
            <div
              className="d-flex align-items-center gap-3"
              style={{ cursor: "pointer" }}
              onClick={() => setUserOpen(!userOpen)}
            >
              <img src="images/avatars/avatar-2.png" className="user-img" alt="user avatar" />
              <div className="user-info">
                <p className="user-name mb-0">Pauline Seitz</p>
                <p className="designattion mb-0">Super Admin</p>
              </div>
            </div>

            {userOpen && (
              <ul className="dropdown-menu dropdown-menu-end show">
                <li>
                  <Link className="dropdown-item d-flex align-items-center" to="/profile">
                    <i className="bx bx-user fs-5"></i>
                    <span>Profile</span>
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item d-flex align-items-center" to="/settings">
                    <i className="bx bx-cog fs-5"></i>
                    <span>Settings</span>
                  </Link>
                </li>
                <li><Link className="dropdown-item d-flex align-items-center" href="/"><i className="bx bx-home-circle fs-5" /><span>Dashboard</span></Link>
                </li>

                <li><div className="dropdown-divider mb-0"></div></li>
                <li>
                  <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#logoutModal">
                    <i className="bx bx-log-out-circle"></i>
                    <span>Logout</span>
                  </button>
                </li>
              </ul>
            )}
          </div>

        </nav>
      </div>
    </header>
  );
};

export default Header;